import "./LoadingModal.css";
import { various } from "../../Data/siteContent";

const LoadingModal = ({ isVisible, message }) => {
  if (!isVisible) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <p>{message || various.processingPayment}</p>
        <div className="spinner"></div>
      </div>
    </div>
  );
};

export default LoadingModal;
